import React from "react";
import { Container, Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CopyRight from "../utils/CopyRight";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";

export default function Footer() {
  return (
    <div className="footer">
      <Paper elevation={0} className="footer-start">
        <Container maxWidth="lg">
          <Grid container spacing={4} className="space-top">
            <Grid item xs={12} md={6} lg={4}>
              <img src="/RX-Pose-white.svg" alt="footer_image" />
              <Typography variant="body2" className="description" gutterBottom>
                RxPose is a non-profit initiative dedicated to making U.S.
                prescription drug price information more transparent and
                accessible to the public.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4} className="office">
              <Typography
                variant="h6"
                className="footer_title heading_four"
                gutterBottom
              >
                Contact
              </Typography>
              <nav>
                <p className="footer-description">
                  <span>
                    <LocalPostOfficeIcon />
                  </span>
                  customer@rxpose.com
                </p>
              </nav>
            </Grid>
            <Grid item xs={6} md={6} lg={2}>
              <div className="footer_menu">
                <Typography
                  variant="h6"
                  className="footer_title heading_four"
                  gutterBottom
                >
                  Menu
                </Typography>
                <nav className="footer_nav_link">
                  <Link to="/">Home</Link>
                  <Link to="/medicines">Browse Medications</Link>
                  <Link to="/contact-congressman">Contact Congressman</Link>
                  <Link to="/healthcare">Healthcare in America</Link>
                  <Link to="/contact">Contact</Link>
                </nav>
              </div>
            </Grid>
            <Grid item xs={6} md={6} lg={2}>
              <div className="footer_menu">
                <Typography
                  variant="h6"
                  className="footer_title heading_four"
                  gutterBottom
                >
                  Category
                </Typography>
                <nav className="footer_nav_link">
                  <Link to="/medicines">Acid Reflux</Link>
                  <Link to="/medicines">Diabetes</Link>
                  <Link to="/medicines">Heart Health</Link>
                  <Link to="/medicines">Mental Health</Link>
                  <Link to="/medicines">Cancer</Link>
                  <Link to="/medicines">High Cholesterol</Link>
                </nav>
              </div>
            </Grid>
          </Grid>
        </Container>
        <CopyRight />
      </Paper>
    </div>
  );
}
